import { ref } from "vue";

export const alertTableQrCodeShow = ref(false);